import { useEffect, useState } from "react";
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import API_BASE_URL from "../../../../Constants";

export default function DispatchHours(){
    const [employeeLogs, setEmployeeLogs] = useState([]);
    const [completeEmployeeLogs, setCompleteEmployeeLogs] = useState([]);
    const [buildingSites, setBuildingSites]= useState(new Map());
    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");
    const [includeMaintenance, setIncludeMaintenance] = useState(false);
    const [buildingSitesArray, setBuildingSitesArray]= useState([]);



    useEffect(() => {
        // Fetch all employee logs
        const fetchEmployeeLog = async () => {
            try {
                const response = await fetch(`${API_BASE_URL}/api/admin/log/allLogs`, {
                    credentials: 'include',
                });
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                const data = await response.json();
                setEmployeeLogs(data);
                setCompleteEmployeeLogs(data);
            }
            catch (error) {
                console.error('Fetch error: ', error);
            }
        };

    fetchEmployeeLog();
    },[])


    useEffect(() => {
        filterDate();
    }, [startDate, endDate, includeMaintenance]);



    // Condense Data if data exists to condense
    useEffect(() => {
        if (employeeLogs.length > 0) {
            condenseData();
        }
    }, [employeeLogs,includeMaintenance]);

    // Need to transfer buildingSites map to Array for export
    useEffect(() => {
        const entriesArray = Array.from(buildingSites.entries()).map(([location, data]) => ({
            location,
            ...data
        }));
        setBuildingSitesArray(entriesArray);
    }, [buildingSites])



    // Filters based on start and end date if set
    const filterDate = () => {
        if (startDate !== "" && endDate !== "") {
            setEmployeeLogs(completeEmployeeLogs.filter((log) => new Date(log.date) >= new Date(startDate) && new Date(log.date) <= new Date(endDate)));
        } 
        else {
            setEmployeeLogs(completeEmployeeLogs);
        }
    };

    //Export to .xlsx file and download functionality
    const exportData = (data, filename) => {
        const worksheet = XLSX.utils.json_to_sheet(data);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
        const wbout = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
        saveAs(new Blob([wbout], { type: 'application/octet-stream' }), filename);
    }


    //Condeses data from employee logs into a map <building name , {accumulation of hours}>
    const condenseData = () => {
        const newBuildingSites = [];
        employeeLogs.forEach(building => {
            if (!includeMaintenance && building.dispatchType === 'Maintenance') {
                return;
            }
            const index = newBuildingSites.findIndex(site => site.location === building.location);
            if (index === -1) {
                newBuildingSites.push({
                    location: building.location,
                    regularHours: building.hours,
                    overtime: building.overtime
                });
            } else {
                newBuildingSites[index].regularHours += building.hours;
                newBuildingSites[index].overtime += building.overtime;
            }
        });
        setBuildingSitesArray(newBuildingSites);
    };
    

    return (
        <div className="mx-auto h-screen w-full">
        <table className="min-w-full bg-white rounded-lg shadow-lg overflow-hidden border-2 mt-11 border-gray-200">
        <thead className="bg-gray-200 w-full">
                    <tr >
                        <td className="text-right px-4 py-4 font-semibold text-gray-600">Date From:</td>
                        <td>
                            <input type="date" name="dateStart" className="border-2 border-gray-700 border-opacity-40 h-10 rounded-md focus:outline-none" onChange={(e) => { setStartDate(new Date(e.target.value)); filterDate()}}/>
                        </td>
                        <td className="px-4 py-4 font-semibold text-gray-600" colSpan={2}>
                            <input type="checkbox" className="mx-2 accent-blue-500" onChange={() => setIncludeMaintenance(!includeMaintenance)}/>
                            Include Maintenance
                        </td>
                    </tr>
                    <tr >
                        <td className="text-right px-4 py-2 font-semibold text-gray-600">Date To:</td>
                        <td>
                            <input type="date" name="dateStart" className="border-2 border-gray-700 border-opacity-40 h-10 rounded-md focus:outline-none"onChange={(e) => { setEndDate(new Date(e.target.value)); filterDate()}}/>
                        </td>
                        <td colSpan={2}>                            
                            <button className="w-1/4 py-2 mx-4 bg-blue-500 text-white font-semibold rounded-md hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-400" onClick={() => exportData(buildingSitesArray,'DispatchHours.xlsx')}>Export Excel</button>

                        </td>
                    </tr>
                    
                    {/* Blank row for space between table headers and functions header*/}
                    <tr className="h-10">
                        <td colSpan={5}></td>
                    </tr>
                </thead>
            <thead className="bg-gray-200">
                    <tr>
                        <th className="px-4 py-2 font-semibold text-gray-600">Building Site</th>
                        <th className="px-4 py-2 font-semibold text-gray-600">Regular Hours</th>
                        <th className="px-4 py-2 font-semibold text-gray-600">Overtime Hours</th>
                        <th className="px-4 py-2 font-semibold text-gray-600">Total Hours</th>
                    </tr>
                </thead>
                <tbody className="text-gray-700">
                {buildingSitesArray.map((building) => (
                    <tr key={building.location} className="border-t">
                        <td className="px-4 py-2 text-center">{building.location}</td>
                        <td className="px-4 py-2 text-center">{building.regularHours.toFixed(2)}</td>
                        <td className="px-4 py-2 text-center">{building.overtime.toFixed(2)}</td>
                        <td className="px-4 py-2 text-center">{(building.regularHours + building.overtime).toFixed(2)}</td>
                    </tr>
                ))}

            </tbody>
        </table>
</div>
    )
}